module.exports = __webpack_public_path__ + "assets/img/flower.5b6d88c4.png";